import QuoteView from '../../../quotes/view/quoteView';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import CustomQuoteDocument from '../../../documents/customQuoteDocument';
import AddCustomDocumentForm from './AddCustomDocumentForm';

export default class AddCustomDocumentModalComponent extends React.Component {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    onDocumentCreated: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
  };

  initializeCustomDocument = () => {
    return new CustomQuoteDocument({ quoteId: this.props.quote.id });
  };

  state = {
    customDocument: this.initializeCustomDocument(),
    submitting: false,
  };

  save = () => {
    this.setState({ submitting: true });
    const savePromise = CustomQuoteDocument.create(
      this.props.quote.id,
      this.state.customDocument
    );
    savePromise
      .then(() => {
        this.props.onDocumentCreated();
        this.hide();
        this.setState({ customDocument: this.initializeCustomDocument() });
      })
      .finally(() => this.setState({ submitting: false }));
  };

  hide = () => this.props.hideModal();

  render() {
    return (
      <Modal
        title="Add Custom Document"
        show={this.props.showModal}
        showCancel={true}
        onOk={this.save}
        onCancel={this.hide}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        submitting={this.state.submitting}
        closeOnOk={false}
      >
        <AddCustomDocumentForm
          customDocument={this.state.customDocument}
          customDocumentChanged={(customDocument) =>
            this.setState({ customDocument })
          }
        />
      </Modal>
    );
  }
}
